import { IAppState } from '../../redux';

export const selectPreferredCommunicationType = (state: IAppState) =>
  state.offer.communication?.preferredCommunicationType ?? null;
